module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av479-4d9c65aed13c15795675395b93422ce8.jpg";